import { SimpleGrid } from "@chakra-ui/react";
import { BsBook, BsClock, BsPerson } from "react-icons/bs";
import StatisticCard from "components/statistic/statistic-card";
import moment from "moment";

interface ProgramStatisticProps {
    program: any
}

const ProgramStatistic: React.FC<ProgramStatisticProps> = ({ program }) => {
    return (
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 5, lg: 8 }}>
            <StatisticCard
                title={'Lessons'}
                stat={program.totalLesson}
                icon={<BsBook size={'2em'} />}
            />
            <StatisticCard
                title={'Durasi'}
                stat={`${moment.duration(program.totalDuration).hours()} jam ${moment.duration(program.totalDuration).minutes().toPrecision(2)} menit`}
                icon={<BsClock size={'2em'} />}
            />
            <StatisticCard
                title={'Enrolled'}
                stat={program.enrolled}
                icon={<BsPerson size={'2em'} />}
            />
        </SimpleGrid>
    )
};

export default ProgramStatistic;